<template>
<div class="container-md col-lg-8 col-md-8">
    <AddPartner @submit="registerPartner"/>
</div>
</template>
<script>
import AddPartner from "@/containers/Partner/AddPartner";
import { mapActions } from 'vuex';
export default {
  components: {
    AddPartner,
  },
  methods:{
    ...mapActions(["addPartner"]),
    registerPartner(data){
      this.addPartner(data);
    }
  }
};
</script>